import script from "./NotificationsOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsOption.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationsOption.vue?vue&type=style&index=0&id=fa65f094&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa65f094"]])

export default __exports__